var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRacesenseMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "46 53 218 157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cb312b;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.09,206.57H216.74l-52.88-61H127.35L90.68,206.81H49.27l36.35-61.24L103,116.25h91.65a19.79,19.79,0,0,0,12.23-4.57c3.43-2.82,5.77-6.72,5.77-11C213.3,91.81,208.09,85,195.39,85H108.74l-28-28.7H206.62c12.76,0,23.52,4.31,31.07,11.28a36.71,36.71,0,0,1,11.93,27.25c.42,26.06-18.78,45.46-43.11,49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRacesenseMark);
export default __webpack_public_path__ + "static/media/logo-racesense-mark.1abbe8821bbe7601f94e1a479ab8a135.svg";
export { ForwardRef as ReactComponent };